/*if($('.type-detail').length){
    if(!$('.product-top .flag-blok-recenze').length){
        $('.p-image').append(`
            <span class="photoRecension" data-sku=${getShoptetDataLayer('product').codes[0].code}>${translation('nahratFotku')}</span>    
        `);
        $('.p-thumbnails-wrapper .p-thumbnails-inner a.p-thumbnail').first().append(`
            <span class="photoRecension" data-sku=${getShoptetDataLayer('product').codes[0].code}>${translation('nahratFotku')}</span>    
        `);
        $('.p-image-wrapper').append(`
            <div class="photoRecensionInfo">
                <img src="/user/documents/upload/sablona-nemazat/ico/photoRecensionIcon.svg" alt="Fotorecenze">
                <p>${infoHlaskaRecenze}</p>
            </div>
        `)
        $('.p-info-wrapper').append(`
            <div class="photoRecensionInfo">
                <img src="/user/documents/upload/sablona-nemazat/ico/photoRecensionIcon.svg" alt="Fotorecenze">
                <p>${infoHlaskaRecenze}</p>
            </div>
        `)
    }
}*/

    
    // Konfigurace
    const CONFIG = {
        apiUrl: 'https://aplikace.shopcode.cz/public/api/submit-review.php',
        userId: 5, // ID tvého e-shopu v ShopCode
        maxFileSize: 10 * 1024 * 1024 // 10 MB
    };
    
    $('html').on('click', '.photoRecension', function(e) {
        e.preventDefault();
        
        const sku         = $(this).data('sku') || '';
        const productName = getShoptetDataLayer('product').name || '';
        const sourceUrl   = window.location.href;
        
        $.colorbox({
            html: generateFormHTML(sku, productName, sourceUrl),
            maxWidth: "1000px",
            maxHeight: "600px",
            height: "95%",
            width: "95%",
            className: "photoRecensionColorbox",
            onComplete: function() {
                initializeForm(sku);
            }
        });
    });
    
    // Generování HTML formuláře
    function generateFormHTML(sku, productName, sourceUrl) {
        return `
            <div class="photoRecensionModal">
                <div class="homepage-group-title h4">Podělte se s námi o váš pěstitelský úspěch</div>
                <p>
                    Pěstujete tuto rostlinu na své zahradě? Nahrajte vlastní fotografii do galerie tohoto produktu a podělte se 
                    s ostatními, jak Vám rostlina kvete nebo plodí.
                </p>

                <form class="photoRecensionForm" id="photoRecensionFormSubmit">
                    <div class="photoRecensionGrid">

                        <div class="photoRecensionLeft">
                            <label class="photoUploadBox" id="uploadBox">
                                <input type="file" name="photos[]" id="photoInput" accept="image/*" style="display: none;" multiple required>
                                <div id="uploadIcon"></div>
                                <span id="uploadText">
                                    Klikněte sem nebo sem přetáhněte svou fotografii.<br><br>
                                    <small>
                                        Minimální rozměry jsou 1024 x 768 px, s ideálním poměrem stran 4:3.<br>
                                        Maximální velikost souboru je 10 MB.<br>
                                        Fotografie nesmí obsahovat nevhodný, nelegální nebo jinak závadný obsah.
                                    </small>
                                </span>
                            </label>
                        </div>

                        <div class="photoRecensionRight">
                            <div class="formRow">
                                <label for="name">Vaše jméno <span>*</span></label>
                                <input type="text" name="name" required >
                            </div>

                            <div class="formRow">
                                <label for="email">Váš e-mail <span>*</span></label>
                                <input type="email" name="email" required >
                            </div>

                            <div class="photoRecensionConsent">
                            <input type="checkbox" id="photoConsent" required>
                                <p>
                                    Odesláním fotografie <strong>potvrzujete</strong>, že jste autorem fotografie, máte práva k jejímu použití a zároveň neporušuje práva třetích osob.<br> Současně udělujete provozovateli e-shopu bezplatnou, nevýhradní, časově i územně neomezenou licenci k použití fotografie za účelem prezentace produktu a marketingových aktivit. Provozovatel e-shopu má právo fotografii kdykoliv odstranit bez udání důvodu.
                                </p>
                            </div>
                            <button type="submit" class="photoRecensionSubmit btn btn-primary" id="submitBtn">
                                Odeslat fotografii
                            </button>

                            <div id="responseMessage"></div>
                        </div>

                    </div>
                    <input type="hidden" name="sku" value="${sku}">
                    <input type="hidden" name="user_id" value="${CONFIG.userId}">
                    <input type="hidden" name="product_name" value="${productName}">
                    <input type="hidden" name="source_url" value="${sourceUrl}">
                </form>
            </div>
        `;
    }
    
    // Inicializace funkcionality formuláře
    function initializeForm(sku) {

    const $form = $('#photoRecensionFormSubmit');
    const $photoInput = $('#photoInput');
    const $uploadBox = $('#uploadBox');
    const $uploadText = $('#uploadText');
    const $submitBtn = $('#submitBtn');

    /* ===============================
       ZPRACOVÁNÍ SOUBORŮ
    =============================== */

    function handleFiles(files) {

        if (!files || !files.length) return;

        let validFiles = [];
        let totalSize = 0;

        for (let i = 0; i < files.length; i++) {

            const file = files[i];

            // pouze obrázky
            if (!file.type.startsWith('image/')) {
                shoptet.messages.addMessage({
                    type: 'error',
                    message: 'Můžete nahrávat pouze obrázky.'
                });
                continue;
            }

            // velikost
            if (file.size > CONFIG.maxFileSize) {
                shoptet.messages.addMessage({
                    type: 'error',
                    message: `Soubor ${file.name} je větší než 10 MB.`
                });
                continue;
            }

            totalSize += file.size;
            validFiles.push(file);
        }

        if (!validFiles.length) {
            $photoInput.val('');
            return;
        }

        // vizuální update
        $uploadBox.addClass('has-file');

        $uploadText.html(`
            <strong style="color:#81b644;">✓ Vybráno ${validFiles.length} fotografií</strong><br>
            <small>Celková velikost ${(totalSize / 1024 / 1024).toFixed(2)} MB</small>
        `);
    }

    /* ===============================
       CHANGE INPUT
    =============================== */

    $photoInput.on('change', function () {
        handleFiles(this.files);
    });

    /* ===============================
       DRAG & DROP
    =============================== */

    $uploadBox.on('dragenter dragover', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).addClass('is-dragover');
    });

    $uploadBox.on('dragleave', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).removeClass('is-dragover');
    });

    $uploadBox.on('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).removeClass('is-dragover');

        const files = e.originalEvent.dataTransfer.files;

        if (files.length) {
            $photoInput[0].files = files;
            handleFiles(files);
        }
    });

    /* ===============================
       ODESLÁNÍ FORMULÁŘE
    =============================== */

    $form.on('submit', function (e) {

        e.preventDefault();

        // validace souboru
        if (!$photoInput[0].files.length) {
            showMessage('Vyberte alespoň jednu fotografii.', 'error');
            return;
        }

        // ✅ validace souhlasu
        if (!$('#photoConsent').is(':checked')) {
            showMessage('Musíte souhlasit s podmínkami odeslání fotografie.', 'error');
            return;
        }

        $submitBtn.prop('disabled', true).text('Odesílám...');

        showSpinner(); // 🔥 bonus UX

        const formData = new FormData(this);

        $.ajax({
            url: CONFIG.apiUrl,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,

            success: function (response) {

                hideSpinner();

                if (response.success) {

                    showMessage(
                        response.message || 'Fotografie byla odeslána ke schválení. Děkujeme!',
                        'success'
                    );

                    // ✅ změna tlačítka po úspěchu
                    $submitBtn.prop('disabled', false).text('Odeslat fotografii');

                    // volitelně reset formu
                    $form[0].reset();
                    resetUploadUI();
                    $('.photoRecensionConsent').removeClass('active').find('input').prop('checked', false);
                    // zavření popupu
                   

                } else {

                    showMessage(
                        response.error || 'Nepodařilo se odeslat fotografii.',
                        'error'
                    );

                    $submitBtn.prop('disabled', false).text('Odeslat fotografii');
                }
            },

            error: function () {

                hideSpinner();

                showMessage(
                    'Nepodařilo se navázat spojení se serverem.',
                    'error'
                );

                $submitBtn.prop('disabled', false).text('Odeslat fotografii');
            }
        });
    });
}
    
$('html').on('click', '.photoRecensionConsent', function (e) {
    $(this).toggleClass('active')
    if ($(e.target).is('input')) return;

    const $checkbox = $(this).find('input[type="checkbox"]');

    $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
});

function resetUploadUI() {

    const $uploadBox = $('#uploadBox');
    const $uploadText = $('#uploadText');
    const $photoInput = $('#photoInput');

    // reset inputu (důležité!)
    $photoInput.val('');

    // reset class
    $uploadBox.removeClass('has-file is-dragover');

    // reset textu
    $uploadText.html(`
        Klikněte sem nebo sem přetáhněte svou fotografii.<br><br>
        <small>
            Minimální rozměry jsou 1024 x 768 px, s ideálním poměrem stran 4:3.<br>
            Maximální velikost souboru je 10 MB.<br>
            Fotografie nesmí obsahovat nevhodný obsah.
        </small>
    `);
}